export default {
  formId: "sub-organization-form",
  formField: {
    subOrganizationKey: {
      name: "subOrganizationKey",
      label: "Sub Organization Title",
      type: "text",
      placeholder: "eg. SUB_ORG_TITLE",
      size: "large",
      errorMsg: "Sub Organization Title is required.",
    },
    country: {
      name: "country",
      label: "Country",
      type: "text",
      placeholder: "Enter a country",
      size: "large",
    },
    city: {
      name: "city",
      label: "City",
      type: "text",
      placeholder: "Enter a city",
      size: "large",
    },
    district: {
      name: "district",
      label: "District",
      type: "text",
      placeholder: "Enter a district",
      size: "large",
    },
    address: {
      name: "address",
      label: "Address",
      type: "text",
      placeholder: "Enter a address",
      size: "large",
    },
    phone: {
      name: "phone",
      label: "Phone",
      type: "text",
      placeholder: "Enter a phone",
      size: "large",
      maxLength: 11,
    },
    email: {
      name: "email",
      label: "Email",
      type: "text",
      placeholder: "Enter a email",
      size: "large",
    },
    organization: {
      name: "organization",
      label: "Organization",
      type: "select",
      size: "large",
      isMulti: false,
      placeholder: "Select an organization",
      errorMsg: "Organization is required.",
    },
  },
};
